module.exports = __webpack_public_path__ + "static/media/gold-coin-bg-wide-2.19d5dcb7.jpg";